import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'my-footer',
  template: require('./footer.component.html'),
  styles: [require('./footer.component.scss')]
})
export class FooterComponent implements OnInit {
  private year: number = (new Date()).getFullYear();

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/footer.component.ts